import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { LuArrowRight, LuBookOpen, LuCheck, LuEye, LuMousePointerClick, LuQuote, LuGlobe, LuStar } from 'react-icons/lu'
import { motion, useInView } from 'framer-motion'
import { Badge } from './components/badge'
import { Button } from './components/button'
import { Card } from './components/card'
import SEOHead from './components/SEOhead'

// Animated counter component
function AnimatedCounter({
  target,
  duration = 2000,
  increment = true,
  incrementRate = 3,
  incrementInterval = 2000,
  startValue = 0
}: any) {
  const [count, setCount] = useState(startValue)
  const [hasAnimated, setHasAnimated] = useState(false)
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, amount: 0.1, margin: '-100px' })

  useEffect(() => {
    if (isInView && !hasAnimated) {
      setHasAnimated(true)
      const startTime = Date.now()

      const animate = () => {
        const now = Date.now()
        const progress = Math.min((now - startTime) / duration, 1)
        const easeOutQuart = 1 - Math.pow(1 - progress, 4)
        const currentCount = Math.floor(startValue + easeOutQuart * (target - startValue))

        setCount(currentCount)

        if (progress < 1) {
          requestAnimationFrame(animate)
        } else if (increment) {
          // Continue incrementing after reaching target
          const interval = setInterval(() => {
            setCount((prev: any) => prev + incrementRate)
          }, incrementInterval)

          return () => clearInterval(interval)
        }
      }

      animate()
    }
  }, [isInView, target, duration, hasAnimated, increment, incrementRate, incrementInterval, startValue])

  return <span ref={ref}>{count.toLocaleString()}</span>
}

export default function DotAdsLanding() {
  const navigate = useNavigate()

  const handleTryNow = () => {
    navigate('/register')
  }

  const handleCreateAccount = () => {
    navigate('/register')
  }

  const openCalendly = (e: { preventDefault: () => void }) => {
    if (e) e.preventDefault()

    if (window.Calendly && window.Calendly.initPopupWidget) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/d/dxg-58r-rm4/introduction-to-dot-discovery-call?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=dd4caa'
      })
    } else {
      window.open(
        'https://calendly.com/d/dxg-58r-rm4/introduction-to-dot-discovery-call?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=dd4caa',
        '_blank',
        'width=800,height=800'
      )
    }

    return false
  }

  const testimonials = [
    {
      quote: 'DOT became our lowest cost source of installs for the Token.com app',
      author: 'Matheus Faria de Paula',
      role: 'Head of Marketing',
      company: 'Token.com',
      image:
        'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/80bff0db0_1562157540058.jpeg',
      logo: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/d7bcb2c3a_tokenwhite.png'
    },
    {
      quote: "DOT's Meta strategy captures and converts real money users at extremely low CAC!",
      author: 'Jeff Donnelley',
      role: 'Marketing Consultant',
      company: 'Wild Casino',
      image:
        'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/c37d72896_image.png',
      logo: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/c0a1bf67b_WildLogoWhite.png'
    },
    {
      quote:
        'DOT has offered us a rapid way to grow registrations and first time deposits (FTD) within our target markets.',
      author: 'Jessica Van Lier',
      role: 'Marketing Manager',
      company: 'BC Game',
      image:
        'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/04703b5b3_Untitleddesign26.png',
      logo: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/d90421651_BCGameWhite.png'
    }
  ]

  const partnerLogos = [
    {
      src: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/ee7b51e29_image28.png',
      alt: 'Trezor'
    },
    {
      src: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/51d255fc4_SolflareWhite.png',
      alt: 'Solflare'
    },
    {
      src: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/8660d7616_Untitleddesign24.png',
      alt: 'Animoca Brands'
    },
    {
      src: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/c0a1bf67b_WildLogoWhite.png',
      alt: 'Wild Casino'
    },
    {
      src: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/d90421651_BCGameWhite.png',
      alt: 'BC Game'
    }
  ]

  return (
    <div className="bg-[#0D0D0D] min-h-screen overflow-hidden">
      <SEOHead
        title="DOT Ads | 175M Crypto & iGaming Users - Get Conversions"
        description="Reach 175M+ engaged Crypto & iGaming users with DOT Ads. Hyper-targeted audiences, real-time analytics, no restrictions. Trusted by 5,000+ brands. Start free today."
        image="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/da70bf8dc_NwIcons7.png"
        url="https://dotaudiences.com/dot-ads"
      />
      <style>{`
        .glow-text {
          text-shadow: 0 0 30px rgba(155, 92, 255, 0.5);
        }
        .glow-button {
          box-shadow: 0 0 30px rgba(155, 92, 255, 0.3);
        }
        .glow-button:hover {
          box-shadow: 0 0 40px rgba(155, 92, 255, 0.5);
        }
        .glow-card {
          box-shadow: 0 0 60px rgba(155, 92, 255, 0.2);
        }
        @keyframes pulse-subtle {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.02); }
        }
        .pulse-subtle {
          animation: pulse-subtle 3s ease-in-out infinite;
        }
        .feature-section {
          transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .feature-section:hover {
          transform: translateY(-4px);
        }
        `}</style>

      {/* Section 1: Hero */}
      <section className="relative min-h-[75vh] flex items-center pt-6 pb-12 lg:py-12">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 left-10 w-72 h-72 bg-[#9B5CFF] rounded-full mix-blend-screen filter blur-3xl opacity-20 animate-pulse"></div>
          <div
            className="absolute top-40 right-10 w-72 h-72 bg-[#EC4899] rounded-full mix-blend-screen filter blur-3xl opacity-20 animate-pulse"
            style={{ animationDelay: '2s' }}
          ></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center lg:text-left"
            >
              <div className="flex justify-center lg:justify-start">
                <Badge className="mb-6 bg-white/5 backdrop-blur-xl text-white border-solid border-white/10 px-4 py-2">
                  ⭐ Loved by 5,000+ Crypto & iGaming Brands
                </Badge>
              </div>

              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
                <span className="bg-gradient-to-r from-[#9B5CFF] to-[#EC4899] bg-clip-text text-transparent glow-text">
                  175 Million
                </span>{' '}
                Crypto & iGaming Users
              </h1>
              <p className="text-xl sm:text-2xl text-[#BFBFBF] mb-8">Get Conversions with DOT Ads</p>
              <div className="flex justify-center lg:justify-start">
                <Button
                  onClick={handleTryNow}
                  size="lg"
                  className="bg-gradient-to-r from-[#9B5CFF] to-[#EC4899] hover:from-[#8B4CFF] hover:to-[#DB2777] text-white px-8 py-6 text-lg font-semibold glow-button mb-8"
                >
                  Create Free Account <LuArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </div>

              {/* Trust Badge */}
              <div className="flex flex-col lg:flex-row items-center justify-center lg:justify-start gap-2 lg:gap-3 mb-8">
                <div className="flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <LuStar key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <span className="text-white font-semibold">Excellent</span>
                <span className="text-[#9E9E9E] hidden lg:inline">| For Crypto & Gaming Brands</span>
              </div>

              {/* Partner Logos */}
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 sm:gap-6 opacity-60">
                {partnerLogos.slice(0, 4).map((logo, idx) => (
                  <img
                    key={idx}
                    src={logo.src}
                    alt={logo.alt}
                    className="h-7 sm:h-8 lg:h-9 w-auto brightness-0 invert hover:opacity-100 transition-opacity"
                  />
                ))}
                <img
                  src={partnerLogos[4].src}
                  alt={partnerLogos[4].alt}
                  className="hidden lg:block h-9 w-auto brightness-0 invert hover:opacity-100 transition-opacity"
                />
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative hidden lg:block"
            >
              <div className="relative overflow-visible">
                <div className="absolute inset-0 bg-gradient-to-r from-[#9B5CFF] to-[#EC4899] rounded-2xl blur-3xl opacity-20 scale-125"></div>
                <img
                  src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/da70bf8dc_NwIcons7.png"
                  alt="DOT Platform Dashboard"
                  className="relative rounded-3xl shadow-3xl border border-solid border-white/10 scale-125 origin-left"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 relative overflow-hidden border-y border-solid border-white/5 flex items-center min-h-[216px]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full">
          {/* Since 2020 Badge */}
          <div className="absolute -top-6 left-8 z-20">
            <Badge className="bg-white/5 border-white/10 text-white/60 px-3 py-1 text-xs font-mono -rotate-12 shadow-lg">
              SINCE 2020
            </Badge>
          </div>

          <div className="relative flex items-center justify-between">
            {/* Connecting lines */}
            <div className="absolute top-8 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent hidden md:block"></div>

            <div className="grid md:grid-cols-3 gap-8 w-full relative z-10">
              {/* Impressions */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="text-center bg-[#0D0D0D] px-4"
              >
                <div className="w-12 h-12 bg-[#9B5CFF]/10 rounded-xl flex items-center justify-center mx-auto mb-3 border border-solid border-[#9B5CFF]/30">
                  <LuEye className="w-6 h-6 text-[#9B5CFF]" />
                </div>
                <div className="text-3xl sm:text-4xl font-bold text-white mb-1 overflow-hidden">
                  <AnimatedCounter
                    target={875006150}
                    startValue={0}
                    increment={true}
                    incrementRate={122}
                    incrementInterval={3000}
                  />
                  +
                </div>
                <p className="text-sm text-white font-medium">Impressions</p>
              </motion.div>

              {/* Conversions */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="text-center bg-[#0D0D0D] px-4"
              >
                <div className="w-12 h-12 bg-[#EC4899]/10 rounded-xl flex items-center justify-center mx-auto mb-3 border border-solid border-[#EC4899]/30">
                  <LuMousePointerClick className="w-6 h-6 text-[#EC4899]" />
                </div>
                <div className="text-3xl sm:text-4xl font-bold text-white mb-1 overflow-hidden">
                  <AnimatedCounter
                    target={110062}
                    startValue={0}
                    increment={true}
                    incrementRate={1}
                    incrementInterval={3500}
                  />
                  +
                </div>
                <p className="text-sm text-white font-medium">Conversions</p>
              </motion.div>

              {/* Countries */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="text-center bg-[#0D0D0D] px-4"
              >
                <div className="w-12 h-12 bg-[#F59E0B]/10 rounded-xl flex items-center justify-center mx-auto mb-3 border border-solid border-[#F59E0B]/30">
                  <LuGlobe className="w-6 h-6 text-[#F59E0B]" />
                </div>
                <div className="text-3xl sm:text-4xl font-bold text-white mb-1 overflow-hidden">
                  <AnimatedCounter target={180} increment={false} />
                </div>
                <p className="text-sm text-white font-medium">Countries Targeted</p>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Feature 1 - Hyper Targeted Audiences */}
      <section className="py-12 lg:py-20 relative overflow-hidden group feature-section">
        <div className="absolute inset-0">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `
              linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px),
              linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px)
            `,
              backgroundSize: '40px 40px'
            }}
          ></div>
        </div>
        <motion.div
          className="absolute inset-0 bg-gradient-to-r from-transparent via-[#9B5CFF]/0 to-transparent group-hover:via-[#9B5CFF]/8 transition-all duration-500"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: false, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        />
        <motion.div
          className="absolute top-1/2 left-1/4 w-[500px] h-[500px] bg-[#9B5CFF] rounded-full mix-blend-screen filter blur-3xl pointer-events-none"
          initial={{ opacity: 0.25 }}
          whileInView={{ opacity: [0.25, 0.45, 0.35] }}
          viewport={{ once: false }}
          transition={{ duration: 2, repeat: Infinity, repeatType: 'reverse' }}
        ></motion.div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-24 items-center lg:pl-20">
            <motion.div
              initial={{ opacity: 0, y: 50, scale: 0.95 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="text-center lg:text-left"
            >
              <div className="flex justify-center lg:justify-start">
                <Badge className="mb-4 bg-[#9B5CFF]/20 text-[#9B5CFF] border-[#9B5CFF]/30">Precision Targeting</Badge>
              </div>
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">Hyper Targeted Audiences</h2>
              <ul className="space-y-3 mb-8 text-left">
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Reach 175M+ engaged Crypto & iGaming users</span>
                </li>
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Delve into 900+ niche interest combinations</span>
                </li>
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Set outcome based campaign goals</span>
                </li>
              </ul>
              <div className="flex justify-center lg:justify-start">
                <Button
                  onClick={handleTryNow}
                  size="lg"
                  className="bg-gradient-to-r from-[#9B5CFF] to-[#EC4899] hover:from-[#8B4CFF] hover:to-[#DB2777] text-white px-10 py-7 text-xl font-semibold glow-button pulse-subtle hover:scale-110 transition-transform duration-300"
                >
                  Try Now
                </Button>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative mt-4 lg:mt-0"
            >
              <style>{`
                /* Card 1 Animation */
                @keyframes cardAnim1 {
                  0%, 14% { transform: translateX(0) translateY(0) rotate(-3deg) scale(0.675); opacity: 1; z-index: 6; }
                  16.6%, 100% { transform: translateX(120%) translateY(-10%) rotate(5deg) scale(0.675); opacity: 0; z-index: 6; }
                }

                /* Card 2 Animation */
                @keyframes cardAnim2 {
                  0%, 14% { transform: translateX(15px) translateY(15px) rotate(-3deg) scale(0.675); opacity: 1; z-index: 5; }
                  16.6%, 30% { transform: translateX(0) translateY(0) rotate(-3deg) scale(0.675); opacity: 1; z-index: 5; }
                  33.3%, 100% { transform: translateX(120%) translateY(-5%) rotate(5deg) scale(0.675); opacity: 0; z-index: 5; }
                }

                /* Card 3 Animation */
                @keyframes cardAnim3 {
                  0%, 14% { transform: translateX(30px) translateY(30px) rotate(-3deg) scale(0.675); opacity: 1; z-index: 4; }
                  16.6%, 30% { transform: translateX(15px) translateY(15px) rotate(-3deg) scale(0.675); opacity: 1; z-index: 4; }
                  33.3%, 47% { transform: translateX(0) translateY(0) rotate(-3deg) scale(0.675); opacity: 1; z-index: 4; }
                  50%, 100% { transform: translateX(120%) translateY(0%) rotate(5deg) scale(0.675); opacity: 0; z-index: 4; }
                }

                /* Card 4 Animation */
                @keyframes cardAnim4 {
                  0%, 14% { transform: translateX(45px) translateY(45px) rotate(-3deg) scale(0.675); opacity: 1; z-index: 3; }
                  16.6%, 30% { transform: translateX(30px) translateY(30px) rotate(-3deg) scale(0.675); opacity: 1; z-index: 3; }
                  33.3%, 47% { transform: translateX(15px) translateY(15px) rotate(-3deg) scale(0.675); opacity: 1; z-index: 3; }
                  50%, 63% { transform: translateX(0) translateY(0) rotate(-3deg) scale(0.675); opacity: 1; z-index: 3; }
                  66.6%, 100% { transform: translateX(120%) translateY(5%) rotate(5deg) scale(0.675); opacity: 0; z-index: 3; }
                }

                /* Card 5 Animation */
                @keyframes cardAnim5 {
                  0%, 14% { transform: translateX(60px) translateY(60px) rotate(-3deg) scale(0.675); opacity: 1; z-index: 2; }
                  16.6%, 30% { transform: translateX(45px) translateY(45px) rotate(-3deg) scale(0.675); opacity: 1; z-index: 2; }
                  33.3%, 47% { transform: translateX(30px) translateY(30px) rotate(-3deg) scale(0.675); opacity: 1; z-index: 2; }
                  50%, 63% { transform: translateX(15px) translateY(15px) rotate(-3deg) scale(0.675); opacity: 1; z-index: 2; }
                  66.6%, 80% { transform: translateX(0) translateY(0) rotate(-3deg) scale(0.675); opacity: 1; z-index: 2; }
                  83.3%, 100% { transform: translateX(120%) translateY(10%) rotate(5deg) scale(0.675); opacity: 0; z-index: 2; }
                }

                /* Card 6 Animation */
                @keyframes cardAnim6 {
                  0%, 14% { transform: translateX(75px) translateY(75px) rotate(-3deg) scale(0.675); opacity: 1; z-index: 1; }
                  16.6%, 30% { transform: translateX(60px) translateY(60px) rotate(-3deg) scale(0.675); opacity: 1; z-index: 1; }
                  33.3%, 47% { transform: translateX(45px) translateY(45px) rotate(-3deg) scale(0.675); opacity: 1; z-index: 1; }
                  50%, 63% { transform: translateX(30px) translateY(30px) rotate(-3deg) scale(0.675); opacity: 1; z-index: 1; }
                  66.6%, 80% { transform: translateX(15px) translateY(15px) rotate(-3deg) scale(0.675); opacity: 1; z-index: 1; }
                  83.3%, 96% { transform: translateX(0) translateY(0) rotate(-3deg) scale(0.675); opacity: 1; z-index: 1; }
                  100% { transform: translateX(120%) translateY(15%) rotate(5deg) scale(0.675); opacity: 0; z-index: 1; }
                }

                .card-stack {
                  position: relative;
                  height: 300px;
                  background: transparent;
                }
                .stacked-card {
                  position: absolute;
                  transform-origin: top left;
                  background: #0D0D0D;
                  width: 100%;
                }
                .stacked-card:nth-child(1) { animation: cardAnim1 18s ease-in-out infinite; z-index: 6; }
                .stacked-card:nth-child(2) { animation: cardAnim2 18s ease-in-out infinite; z-index: 5; }
                .stacked-card:nth-child(3) { animation: cardAnim3 18s ease-in-out infinite; z-index: 4; }
                .stacked-card:nth-child(4) { animation: cardAnim4 18s ease-in-out infinite; z-index: 3; }
                .stacked-card:nth-child(5) { animation: cardAnim5 18s ease-in-out infinite; z-index: 2; }
                .stacked-card:nth-child(6) { animation: cardAnim6 18s ease-in-out infinite; z-index: 1; }
              `}</style>

              <div className="relative h-auto lg:h-[450px] flex items-center justify-center lg:justify-start py-4 lg:py-0">
                <div className="absolute inset-0 bg-gradient-to-r from-[#9B5CFF] to-[#EC4899] blur-3xl opacity-20"></div>
                <div className="card-stack relative w-full max-w-[420px] z-10 ml-4 lg:ml-0">
                  <div className="stacked-card">
                    <img
                      src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/d44c0bfc9_eSports.png"
                      alt="eSports"
                      className="rounded-xl shadow-2xl border-2 border-solid border-white/10 w-full"
                    />
                  </div>
                  <div className="stacked-card">
                    <img
                      src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/99b780975_TokenLaunch.png"
                      alt="Token Launch"
                      className="rounded-xl shadow-2xl border-2 border-solid border-white/10 w-full"
                    />
                  </div>
                  <div className="stacked-card">
                    <img
                      src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/6559ec194_Casino.png"
                      alt="Casino"
                      className="rounded-xl shadow-2xl border-2 border-solid border-white/10 w-full"
                    />
                  </div>
                  <div className="stacked-card">
                    <img
                      src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/bc43ca45a_TradingDeFi.png"
                      alt="Trading & DeFi"
                      className="rounded-xl shadow-2xl border-2 border-solid border-white/10 w-full"
                    />
                  </div>
                  <div className="stacked-card">
                    <img
                      src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/8d464c83e_CryptoProfessionals.png"
                      alt="Crypto Professionals"
                      className="rounded-xl shadow-2xl border-2 border-solid border-white/10 w-full"
                    />
                  </div>
                  <div className="stacked-card">
                    <img
                      src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/f5fd1ddf1_NFTCollectables.png"
                      alt="NFT & Collectables"
                      className="rounded-xl shadow-2xl border-2 border-solid border-white/10 w-full"
                    />
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Section 3: Feature 2 - 100% Self Serve */}
      <section className="py-12 lg:py-20 relative overflow-hidden group feature-section">
        <div className="absolute inset-0">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `
              linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px),
              linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px)
            `,
              backgroundSize: '40px 40px'
            }}
          ></div>
        </div>
        <motion.div
          className="absolute inset-0 bg-gradient-to-r from-transparent via-[#10B981]/0 to-transparent group-hover:via-[#10B981]/8 transition-all duration-500"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: false, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        />
        <motion.div
          className="absolute top-1/2 right-1/4 w-[500px] h-[500px] bg-[#10B981] rounded-full mix-blend-screen filter blur-3xl pointer-events-none"
          initial={{ opacity: 0.25 }}
          whileInView={{ opacity: [0.25, 0.45, 0.35] }}
          viewport={{ once: false }}
          transition={{ duration: 2, repeat: Infinity, repeatType: 'reverse' }}
        ></motion.div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-28 items-center lg:pl-20">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="order-2 lg:order-1"
            >
              <div className="flex justify-center lg:justify-start">
                <img
                  src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/a260f1072_image.png"
                  alt="Self Serve Dashboard"
                  className="rounded-2xl shadow-2xl border-2 border-solid border-white/10 w-full max-w-lg hover:scale-105 transition-transform duration-300"
                />
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="order-1 lg:order-2 text-center lg:text-left"
            >
              <div className="flex justify-center lg:justify-start">
                <Badge className="mb-4 bg-[#10B981]/20 text-[#10B981] border-[#10B981]/30">Self-Serve</Badge>
              </div>
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">100% Self-Serve</h2>
              <ul className="space-y-3 mb-8 text-left">
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Intuitive platform offering complete control</span>
                </li>
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Easily set and update campaigns at any time</span>
                </li>
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Our professional support team is available if you need</span>
                </li>
              </ul>
              <div className="flex justify-center lg:justify-start">
                <Button
                  onClick={handleTryNow}
                  size="lg"
                  className="bg-gradient-to-r from-[#9B5CFF] to-[#EC4899] hover:from-[#8B4CFF] hover:to-[#DB2777] text-white px-10 py-7 text-xl font-semibold glow-button pulse-subtle hover:scale-110 transition-transform duration-300"
                >
                  Try Now
                </Button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Section 4: Feature 3 - Bypass Restrictions */}
      <section className="py-12 lg:py-20 relative overflow-hidden group feature-section">
        <div className="absolute inset-0">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `
              linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px),
              linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px)
            `,
              backgroundSize: '40px 40px'
            }}
          ></div>
        </div>
        <motion.div
          className="absolute inset-0 bg-gradient-to-r from-transparent via-[#EC4899]/0 to-transparent group-hover:via-[#EC4899]/8 transition-all duration-500"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: false, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        />
        <motion.div
          className="absolute top-1/2 left-1/4 w-[500px] h-[500px] bg-[#EC4899] rounded-full mix-blend-screen filter blur-3xl pointer-events-none"
          initial={{ opacity: 0.25 }}
          whileInView={{ opacity: [0.25, 0.45, 0.35] }}
          viewport={{ once: false }}
          transition={{ duration: 2, repeat: Infinity, repeatType: 'reverse' }}
        ></motion.div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-28 items-center lg:pl-20">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="text-center lg:text-left"
            >
              <div className="flex justify-center lg:justify-start">
                <Badge className="mb-4 bg-[#EC4899]/20 text-[#EC4899] border-[#EC4899]/30">No Limitations</Badge>
              </div>
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">Bypass Restrictions</h2>
              <ul className="space-y-3 mb-8 text-left">
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Break free from Google & Facebook restrictions</span>
                </li>
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Advertise crypto and iGaming without limits</span>
                </li>
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Take back control of your growth strategy</span>
                </li>
              </ul>
              <div className="flex justify-center lg:justify-start">
                <Button
                  onClick={handleTryNow}
                  size="lg"
                  className="bg-gradient-to-r from-[#9B5CFF] to-[#EC4899] hover:from-[#8B4CFF] hover:to-[#DB2777] text-white px-10 py-7 text-xl font-semibold glow-button pulse-subtle hover:scale-110 transition-transform duration-300"
                >
                  Try Now
                </Button>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative"
            >
              <div className="flex items-center justify-center h-full">
                <img
                  src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/33eeb1db4_image.png"
                  alt="Bypass Restrictions"
                  className="rounded-2xl shadow-2xl border-2 border-solid border-white/10 w-[80%] max-w-sm lg:w-[75%] lg:max-w-md hover:scale-105 transition-transform duration-300"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Section 5: Feature 4 - Flexible Budgets */}
      <section className="py-12 lg:py-20 relative overflow-hidden group feature-section">
        <div className="absolute inset-0">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `
              linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px),
              linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px)
            `,
              backgroundSize: '40px 40px'
            }}
          ></div>
        </div>
        <motion.div
          className="absolute inset-0 bg-gradient-to-r from-transparent via-[#F59E0B]/0 to-transparent group-hover:via-[#F59E0B]/8 transition-all duration-500"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: false, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        />
        <motion.div
          className="absolute top-1/2 right-1/4 w-[500px] h-[500px] bg-[#F59E0B] rounded-full mix-blend-screen filter blur-3xl pointer-events-none"
          initial={{ opacity: 0.25 }}
          whileInView={{ opacity: [0.25, 0.45, 0.35] }}
          viewport={{ once: false }}
          transition={{ duration: 2, repeat: Infinity, repeatType: 'reverse' }}
        ></motion.div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-28 items-center lg:pl-20">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="flex items-center justify-center order-2 lg:order-1 lg:min-h-[480px]"
            >
              <img
                src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/ac77b6779_image.png"
                alt="Flexible Budgets"
                className="rounded-2xl shadow-2xl border-2 border-solid border-white/10 w-full max-w-sm lg:max-w-none lg:scale-[1.15] hover:scale-105 lg:hover:scale-[1.20] transition-transform duration-300"
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="order-1 lg:order-2 text-center lg:text-left"
            >
              <div className="flex justify-center lg:justify-start">
                <Badge className="mb-4 bg-[#F59E0B]/20 text-[#F59E0B] border-[#F59E0B]/30">Budget Control</Badge>
              </div>
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">Flexible Budgets</h2>
              <ul className="space-y-3 mb-8 text-left">
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Start, pause, or adjust spend anytime</span>
                </li>
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>No minimum commitments or contracts</span>
                </li>
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Scale up or down based on performance</span>
                </li>
              </ul>
              <div className="flex justify-center lg:justify-start">
                <Button
                  onClick={handleTryNow}
                  size="lg"
                  className="bg-gradient-to-r from-[#9B5CFF] to-[#EC4899] hover:from-[#8B4CFF] hover:to-[#DB2777] text-white px-10 py-7 text-xl font-semibold glow-button pulse-subtle hover:scale-110 transition-transform duration-300"
                >
                  Try Now
                </Button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Section 6: Feature 5 - Real Time Analytics */}
      <section className="py-12 lg:py-20 relative overflow-hidden group feature-section">
        <div className="absolute inset-0">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `
              linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px),
              linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px)
            `,
              backgroundSize: '40px 40px'
            }}
          ></div>
        </div>
        <motion.div
          className="absolute inset-0 bg-gradient-to-r from-transparent via-[#8B5CF6]/0 to-transparent group-hover:via-[#8B5CF6]/8 transition-all duration-500"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: false, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        />
        <motion.div
          className="absolute top-1/2 left-1/4 w-[500px] h-[500px] bg-[#8B5CF6] rounded-full mix-blend-screen filter blur-3xl pointer-events-none"
          initial={{ opacity: 0.25 }}
          whileInView={{ opacity: [0.25, 0.45, 0.35] }}
          viewport={{ once: false }}
          transition={{ duration: 2, repeat: Infinity, repeatType: 'reverse' }}
        ></motion.div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-28 items-center lg:pl-20">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="text-center lg:text-left"
            >
              <div className="flex justify-center lg:justify-start">
                <Badge className="mb-4 bg-[#8B5CF6]/20 text-[#8B5CF6] border-[#8B5CF6]/30">Live Tracking</Badge>
              </div>
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">Real Time Analytics</h2>
              <ul className="space-y-3 mb-8 text-left">
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Monitor performance live with real-time updates</span>
                </li>
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Complete visibility across all key metrics</span>
                </li>
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Data-driven insights for better decisions</span>
                </li>
              </ul>
              <div className="flex justify-center lg:justify-start">
                <Button
                  onClick={handleTryNow}
                  size="lg"
                  className="bg-gradient-to-r from-[#9B5CFF] to-[#EC4899] hover:from-[#8B4CFF] hover:to-[#DB2777] text-white px-10 py-7 text-xl font-semibold glow-button pulse-subtle hover:scale-110 transition-transform duration-300"
                >
                  Try Now
                </Button>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative"
            >
              <div className="flex items-center justify-center lg:min-h-[520px]">
                <img
                  src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/1e66adf99_image.png"
                  alt="Real Time Analytics"
                  className="rounded-2xl shadow-2xl border-2 border-solid border-white/10 w-full max-w-sm lg:max-w-none transform lg:scale-[1.24] hover:scale-105 lg:hover:scale-[1.29] transition-transform duration-300"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Section 7: Feature 6 - Meta Retargeting Add-On */}
      <section className="py-12 lg:py-20 relative overflow-hidden">
        <div className="absolute inset-0">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `
              linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px),
              linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px)
            `,
              backgroundSize: '40px 40px'
            }}
          ></div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-br from-[#EC4899]/5 via-[#9B5CFF]/5 to-transparent"></div>
        <motion.div
          className="absolute top-1/2 right-1/4 w-96 h-96 bg-[#EC4899] rounded-full mix-blend-screen filter blur-3xl pointer-events-none"
          initial={{ opacity: 0.25 }}
          whileInView={{ opacity: [0.25, 0.45, 0.35] }}
          viewport={{ once: false }}
          transition={{ duration: 2, repeat: Infinity, repeatType: 'reverse' }}
        ></motion.div>
        <motion.div
          className="absolute top-1/2 left-1/4 w-96 h-96 bg-[#9B5CFF] rounded-full mix-blend-screen filter blur-3xl pointer-events-none"
          initial={{ opacity: 0.25 }}
          whileInView={{ opacity: [0.25, 0.5, 0.35] }}
          viewport={{ once: false }}
          transition={{ duration: 2.5, repeat: Infinity, repeatType: 'reverse' }}
        ></motion.div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center lg:text-left mb-8">
            <div className="relative inline-block -rotate-3 hover:rotate-0 transition-transform duration-300">
              <div className="absolute inset-0 bg-gradient-to-r from-[#EC4899] to-[#9B5CFF] blur-lg opacity-50"></div>
              <Badge className="relative bg-gradient-to-r from-[#EC4899] to-[#9B5CFF] text-white border-0 text-base px-6 py-2.5 font-semibold shadow-[0_0_30px_rgba(236,72,153,0.5)] hover:shadow-[0_0_40px_rgba(236,72,153,0.7)] transition-all">
                ✨ Optional Add-On Package
              </Badge>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center lg:pl-20">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="text-center lg:text-left"
            >
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">Meta Retargeting</h2>
              <ul className="space-y-3 mb-8 text-left">
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Aggressive retargeting on Facebook, Instagram & Threads</span>
                </li>
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Convert first-time visitors into customers</span>
                </li>
                <li className="flex items-start gap-3 text-lg text-[#BFBFBF]">
                  <LuCheck className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span>Combines perfectly with DOT Ads campaigns</span>
                </li>
              </ul>
              <div className="flex justify-center lg:justify-start">
                <a href={'https://dotaudiences.com/metaads'} target="_blank" rel="noopener noreferrer">
                  <Button
                    size="lg"
                    className="bg-gradient-to-r from-[#EC4899] to-[#DB2777] hover:from-[#DB2777] hover:to-[#BE185D] text-white px-8 py-6 text-lg font-semibold shadow-[0_0_40px_rgba(236,72,153,0.4)] hover:shadow-[0_0_60px_rgba(236,72,153,0.6)] transition-all"
                  >
                    Learn More About Meta Ads <LuArrowRight className="ml-2 w-5 h-5" />
                  </Button>
                </a>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative"
            >
              <Card className="p-8 bg-gradient-to-br from-[#EC4899]/10 via-[#9B5CFF]/5 to-transparent border-2 border-[#EC4899]/30 backdrop-blur-xl shadow-[0_0_60px_rgba(236,72,153,0.3)]">
                <div className="flex justify-center gap-6 mb-8">
                  <div className="w-16 h-16 bg-gradient-to-br from-[#E4405F] to-[#C13584] rounded-2xl flex items-center justify-center shadow-xl">
                    <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266-.058-1.644-.07-4.85-.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM12 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                  </div>
                  <div className="w-16 h-16 bg-gradient-to-br from-[#1877F2] to-[#0C5BB8] rounded-2xl flex items-center justify-center shadow-xl">
                    <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                  </div>
                  <div className="w-16 h-16 bg-black rounded-2xl flex items-center justify-center shadow-xl p-2">
                    <img
                      src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/95a6d8d67_threads.png"
                      alt="Threads"
                      className="w-full h-full object-cover rounded-xl"
                    />
                  </div>
                </div>
                <div className="relative h-32">
                  <svg className="w-full h-full" viewBox="0 0 400 120">
                    <path
                      d="M 40 60 Q 120 30, 200 60 T 360 60"
                      fill="none"
                      stroke="#EC4899"
                      strokeWidth="3"
                      strokeDasharray="6 6"
                      opacity="0.6"
                    />
                    <circle cx="40" cy="60" r="8" fill="#EC4899" opacity="0.8" />
                    <circle cx="200" cy="60" r="8" fill="#EC4899" opacity="0.8" />
                    <circle cx="360" cy="60" r="8" fill="#EC4899" />
                    <text x="40" y="90" fill="#BFBFBF" fontSize="12" textAnchor="middle">
                      Visitor
                    </text>
                    <text x="200" y="90" fill="#BFBFBF" fontSize="12" textAnchor="middle">
                      Retarget
                    </text>
                    <text x="360" y="90" fill="#EC4899" fontSize="12" textAnchor="middle" fontWeight="bold">
                      Convert
                    </text>
                  </svg>
                </div>
              </Card>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Support Section */}
      <section className="py-20 bg-[#0D0D0D] border border-solid border-y border-white/5 relative overflow-hidden">
        <div className="absolute inset-0">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `
              linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px),
              linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px)
            `,
              backgroundSize: '40px 40px'
            }}
          ></div>
          <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-[#10B981] rounded-full mix-blend-screen filter blur-3xl opacity-10 animate-pulse"></div>
          <div
            className="absolute top-1/2 right-1/4 w-96 h-96 bg-[#9B5CFF] rounded-full mix-blend-screen filter blur-3xl opacity-10 animate-pulse"
            style={{ animationDelay: '2s' }}
          ></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="text-center lg:text-left"
            >
              <Badge className="mb-4 bg-[#10B981]/20 text-[#10B981] border-[#10B981]/30">24/7 Support</Badge>
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">Incredible Support</h2>
              <p className="text-xl text-[#BFBFBF] mb-8">
                Our team is here to help you succeed. Get instant answers from our knowledge base or reach out directly.
              </p>

              <div className="space-y-4 mb-8">
                <div className="flex items-center gap-3 text-[#BFBFBF]">
                  <div className="w-10 h-10 bg-white/5 border border-solid border-white/10 rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-[#0088cc]" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18 1.897-.962 6.502-1.359 8.627-.168.9-.5 1.201-.82 1.23-.697.064-1.226-.461-1.901-.903-1.056-.693-1.653-1.124-2.678-1.8-1.185-.781-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.139-5.062 3.345-.479.329-.913.489-1.302.481-.428-.008-1.252-.241-1.865-.44-.752-.244-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.831-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635.099-.002.321.023.465.14.121.098.155.23.171.324.016.094.036.308.02.475z" />
                    </svg>
                  </div>
                  <span className="text-white font-medium">Live chat via Telegram</span>
                </div>
                <div className="flex items-center gap-3 text-[#BFBFBF]">
                  <div className="w-10 h-10 bg-white/5 border border-solid border-white/10 rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                  </div>
                  <span className="text-white font-medium">Email support available</span>
                </div>
                <div className="flex items-center gap-3 text-[#BFBFBF]">
                  <div className="w-10 h-10 bg-white/5 border border-solid border-white/10 rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-[#4A154B]" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zM18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zM15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z" />
                    </svg>
                  </div>
                  <span className="text-white font-medium">Slack workspace access</span>
                </div>
              </div>

              <a href={'https://dotaudiences.com/support'} target="_blank" rel="noopener noreferrer">
                <Button
                  size="lg"
                  className="bg-[#1A1A1A] border-2 border-dashed border-[#3A3A3A] hover:bg-[#2A2A2A] hover:border-[#4A4A4A] text-[#9E9E9E] hover:text-white px-8 py-6 text-lg font-mono font-semibold transition-all"
                >
                  <LuBookOpen className="w-5 h-5 mr-2" />
                  <span className="font-mono">{'>'} View Support Docs</span>
                </Button>
              </a>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative"
            >
              <div className="relative rounded-xl overflow-hidden border-2 border-solid border-white/10 shadow-2xl">
                <div className="absolute inset-0 bg-gradient-to-r from-[#10B981]/20 to-[#9B5CFF]/20 blur-xl"></div>
                <img
                  src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/959bded93_image.png"
                  alt="Support Documentation"
                  className="relative w-full h-auto"
                  onError={(e: any) => {
                    e.target.src =
                      'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/da70bf8dc_NwIcons7.png'
                  }}
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Section 9: Community Testimonials */}
      <section className="py-16 relative bg-[#0D0D0D] overflow-hidden group">
        <motion.div
          className="absolute inset-0 border-y-2 border-solid border-[#F59E0B]/0 group-hover:bprder-[#F59E0B]/80 transition-all duration-500 shadow-[0_0_0_rgba(245,158,11,0)] group-hover:shadow-[0_0_80px_rgba(245,158,11,0.6),inset_0_0_80px_rgba(245,158,11,0.2)]"
          initial={{ borderColor: 'rgba(245, 158, 11, 0)', boxShadow: '0 0 0 rgba(245, 158, 11, 0)' }}
          whileInView={{
            borderColor: 'rgba(245, 158, 11, 0.5)',
            boxShadow: '0 0 40px rgba(245, 158, 11, 0.3), inset 0 0 40px rgba(245, 158, 11, 0.05)'
          }}
          viewport={{ once: false, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        />
        <motion.div
          className="absolute inset-0 bg-gradient-to-r from-transparent via-[#F59E0B]/0 to-transparent group-hover:via-[#F59E0B]/15 transition-all duration-500"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: false, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        />
        <motion.div
          className="absolute top-1/2 right-1/4 w-[500px] h-[500px] bg-[#F59E0B] rounded-full mix-blend-screen filter blur-3xl pointer-events-none"
          initial={{ opacity: 0.25 }}
          whileInView={{ opacity: [0.25, 0.45, 0.35] }}
          viewport={{ once: false }}
          transition={{ duration: 2, repeat: Infinity, repeatType: 'reverse' }}
        ></motion.div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          {/* Header with dramatic styling */}
          <div className="text-center mb-20">
            <motion.div
              initial={{ opacity: 0, scale: 0.765 }}
              whileInView={{ opacity: 1, scale: 0.85 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="inline-block mb-6">
                <div className="relative">
                  <div className="absolute inset-0 bg-white blur-xl opacity-50"></div>
                  <div className="relative bg-white text-[#9B5CFF] px-8 py-4 rounded-full font-semibold text-lg shadow-[0_0_50px_rgba(255,255,255,0.6)]">
                    ⭐ 5,000+ Happy Customers
                  </div>
                </div>
              </div>
              <h2 className="text-5xl sm:text-6xl font-bold text-white mb-6 drop-shadow-[0_0_30px_rgba(0,0,0,0.5)]">
                The Community Has Spoken
              </h2>
              <p className="text-2xl text-white/90 max-w-3xl mx-auto font-medium">
                Real results from top Crypto & iGaming brands
              </p>
            </motion.div>
          </div>

          {/* Testimonial cards with bold new design */}
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: idx * 0.15 }}
              >
                <div className="relative group h-full">
                  {/* Glow effect on hover */}
                  <div className="absolute -inset-1 bg-gradient-to-r from-[#0D0D0D] to-[#1A1A1A] rounded-2xl opacity-0 group-hover:opacity-100 blur-xl transition-opacity duration-500"></div>

                  {/* Card content */}
                  <Card className="relative h-full bg-gradient-to-br from-[#1A1A1A] to-[#0D0D0D] border-2 border-white/20 rounded-2xl p-8 backdrop-blur-xl shadow-[0_8px_32px_rgba(0,0,0,0.8)] group-hover:border-white/40 group-hover:shadow-[0_0_60px_rgba(0,0,0,0.6)] transition-all duration-300 flex flex-col">
                    {/* Quote icon with gradient */}
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#F59E0B] to-[#EAB308] flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(245,158,11,0.4)]">
                      <LuQuote className="w-6 h-6 text-white" />
                    </div>

                    {/* Testimonial text */}
                    <p className="text-white text-lg font-medium mb-8 leading-relaxed">"{testimonial.quote}"</p>

                    {/* Author section with bold styling */}
                    <div className="border-t border-solid border-white/10 pt-6 mt-auto">
                      <div className="flex items-center gap-4 mb-4">
                        <div className="relative">
                          <div className="absolute inset-0 bg-gradient-to-br from-[#F59E0B] to-[#EAB308] rounded-full blur"></div>
                          <img
                            src={testimonial.image}
                            alt={testimonial.author}
                            className="relative w-14 h-14 rounded-full object-cover border-2 border-solid border-white/30"
                          />
                        </div>
                        <div>
                          <p className="font-bold text-white text-lg">{testimonial.author}</p>
                          <p className="text-sm text-[#BFBFBF]">{testimonial.role}</p>
                        </div>
                      </div>

                      {/* Company logo with prominent display - fixed height */}
                      <div className="bg-white/5 rounded-lg p-4 flex items-center justify-center border border-solid border-white/10 h-24">
                        {testimonial.logo && (
                          <img
                            src={testimonial.logo}
                            alt={testimonial.company}
                            className={`${
                              testimonial.company === 'Token.com'
                                ? 'h-16'
                                : testimonial.company === 'BC Game'
                                ? 'h-10'
                                : 'h-8'
                            } w-auto brightness-0 invert`}
                          />
                        )}
                      </div>

                      {/* Star rating at bottom */}
                      <div className="flex gap-1 mt-6">
                        {[...Array(5)].map((_, i) => (
                          <LuStar key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                        ))}
                      </div>
                    </div>
                  </Card>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 10: Get Started CTA */}
      <section className="relative py-32 bg-gradient-to-br from-[#0D0D0D] via-[#1A0D26] to-[#0D0D0D] border-t border-solid border-[#9B5CFF]/20 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-[#9B5CFF] rounded-full mix-blend-screen filter blur-3xl opacity-30 animate-pulse"></div>
          <div
            className="absolute top-1/2 right-1/4 w-96 h-96 bg-[#EC4899] rounded-full mix-blend-screen filter blur-3xl opacity-30 animate-pulse"
            style={{ animationDelay: '2s' }}
          ></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="text-center lg:text-left">
              <Badge className="mb-6 bg-gradient-to-r from-[#9B5CFF]/20 to-[#EC4899]/20 text-white border-[#9B5CFF]/40 backdrop-blur-sm px-5 py-2 text-base shadow-lg shadow-[#9B5CFF]/20">
                Get Started
              </Badge>
              <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-white">Get Results Today</h2>
              <p className="text-xl sm:text-2xl mb-12 text-[#BFBFBF]">
                Join 5,000+ brands already growing with DOT Ads
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-12">
                <Button
                  size="lg"
                  onClick={handleCreateAccount}
                  className="bg-gradient-to-r from-[#9B5CFF] to-[#EC4899] hover:from-[#8B4CFF] hover:to-[#DB2777] text-white px-10 py-7 text-lg font-bold shadow-2xl shadow-[#9B5CFF]/50 hover:shadow-[#9B5CFF]/70 transition-all hover:scale-105"
                >
                  Create Free Account
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  onClick={openCalendly}
                  className="px-10 py-7 text-lg font-bold border-2 border-white/20 bg-white/5 hover:bg-white/10 text-white backdrop-blur-sm hover:scale-105 transition-all"
                >
                  Book Demo
                </Button>
              </div>
              <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-8 text-base">
                <div className="flex items-center justify-center lg:justify-start gap-2 text-[#BFBFBF]">
                  <LuCheck className="w-5 h-5 text-[#10B981]" />
                  <span>No credit card required</span>
                </div>
                <div className="flex items-center justify-center lg:justify-start gap-2 text-[#BFBFBF]">
                  <LuCheck className="w-5 h-5 text-[#10B981]" />
                  <span>Start in minutes</span>
                </div>
                <div className="flex items-center justify-center lg:justify-start gap-2 text-[#BFBFBF]">
                  <LuCheck className="w-5 h-5 text-[#10B981]" />
                  <span>Cancel anytime</span>
                </div>
              </div>
            </div>

            <div className="relative hidden lg:flex justify-end items-center overflow-visible">
              <div className="relative w-full scale-150 rotate-6 origin-left -mr-48">
                <div className="absolute inset-0 bg-gradient-to-r from-[#9B5CFF] to-[#EC4899] rounded-2xl blur-3xl opacity-20"></div>
                <img
                  src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/da70bf8dc_NwIcons7.png"
                  alt="DOT Platform Dashboard"
                  className="relative rounded-3xl shadow-3xl border border-solid border-white/10"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 12: Newsletter Signup */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8">
            <div className="flex justify-center">
              <iframe
                title="subscribe-embed"
                src="https://blog.dotaudiences.com/embed"
                className="w-full max-w-[480px] h-[320px] border border-solid border-white/10 rounded-lg bg-white"
                frameBorder="0"
                scrolling="no"
              />
            </div>
            <div>
              <iframe
                src="https://server.dotaudiences.com/substackfeed/dotads/6900a8fe8a7555eb6efe760e"
                title="Substack Feed"
                className="w-full h-[900px] lg:h-[560px] border-none rounded-lg"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
